import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withArrow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#C4467E] text-white hover:bg-[#A33668] shadow-md hover:shadow-lg focus:ring-[#C4467E]',
    secondary: 'bg-[#FDE8F0] text-[#C4467E] hover:bg-[#FAD1E0] focus:ring-[#FDE8F0]',
    outline: 'border-2 border-[#C4467E] text-[#C4467E] hover:bg-[#FDE8F0] focus:ring-[#C4467E]'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2',
    md: 'text-base px-6 py-3',
    lg: 'text-lg px-8 py-4'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-251">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-5 w-5" data-id="element-252" />}
    </motion.button>;
}